module.exports = __webpack_public_path__ + "static/media/download_white.0f3514a4.svg";